import { ReactComponent as CompanyLogo } from 'Asset/Logo/company-logo.svg'
import { ReactComponent as CompanySmallLogo } from 'Asset/Logo/company-logo-small.svg'
import { ReactComponent as DepartmentLogo } from 'Asset/Logo/department-logo.svg'
import { ReactComponent as DepartmentSmallLogo } from 'Asset/Logo/department-logo-small.svg'

export default { DepartmentLogo, DepartmentSmallLogo, CompanySmallLogo, CompanyLogo }